const indicatorMatrix = [
  { weightStart: 22, heightStart: 0, code: "A", indicator: [.75, .75, .75, undefined, undefined, undefined, undefined, undefined] },
  { weightStart: 30, heightStart: 0, code: "B", indicator: [1, .75, .75, .75, undefined, undefined, undefined, undefined] },
  { weightStart: 39, heightStart: 0, code: "C", indicator: [1.5, 1.25, 1.25, 1, undefined, undefined, undefined, undefined] },
  { weightStart: 48, heightStart: 0, code: "D", indicator: [2, 1.75, 1.5, 1.5, 1.25, undefined, undefined, undefined] },
  { weightStart: 57, heightStart: 0, code: "E", indicator: [2.5, 2.25, 2, 1.75, 1.5, 1.5, undefined, undefined] },
  { weightStart: 67, heightStart: 0, code: "F", indicator: [3, 2.75, 2.5, 2.25, 2, 1.75, 1.75, undefined] },
  { weightStart: 79, heightStart: 0, code: "G", indicator: [undefined, 3.5, 3, 2.75, 2.5, 2.25, 2, undefined] },
  { weightStart: 92, heightStart: 0, code: "H", indicator: [undefined, undefined, 3.5, 3, 3, 2.75, 2.5, undefined] },
  { weightStart: 108, heightStart: 59, code: "I", indicator: [undefined, undefined, 4.5, 4, 3.5, 3.5, 3, undefined] },
  { weightStart: 126, heightStart: 62, code: "J", indicator: [undefined, undefined, 5.5, 5, 4.5, 4, 3.5, 3] },
  { weightStart: 148, heightStart: 66, code: "K", indicator: [undefined, undefined, 6.5, 6, 5.5, 5, 4.5, 4] },
  { weightStart: 175, heightStart: 71, code: "L", indicator: [undefined, undefined, 7.5, 7, 6.5, 6, 5.5, 5] },
  { weightStart: 210, heightStart: 77, code: "M", indicator: [undefined, undefined, undefined, 8.5, 8, 7, 6.5, 6] },
  { weightStart: 999, heightStart: 999, code: "N", indicator: [undefined, undefined, undefined, 10, 9.5, 8.5, 8, 7.5] },
  { weightStart: 999, heightStart: 999, code: "O", indicator: [undefined, undefined, undefined, 11.5, 11, 10, 9.5, 9] },
  { weightStart: 999, heightStart: 999, code: "P", indicator: [undefined, undefined, undefined, undefined, undefined, 12, 11, 10.5] },
];

const soleBracketStarts = [0, 231, 251, 271, 291, 311, 331, 351];

export function GetIndicator(height, weight, skierType, age, soleLength) {
  // Find the highest row with height & weight less than the given values
  let i = 0;
  for (i = 0; i < indicatorMatrix.length; i++) {
    if (indicatorMatrix[i].heightStart > height || indicatorMatrix[i].weightStart > weight) {
      break;
    }
  }
  i--;

  // Increase the row if intermediate or aggressive skier
  if (skierType === "2") {
    i++;
  } else if (skierType === "3") {
    // Skiers less than 48lb move one row maximum
    if (weight < 48) {
      i += 1;
    } else {
      i += 2;
    }
  }

  // Decrease the row if very young or old
  if (age <= 9 || age >= 50) {
    i--;
  }

  // Limit to within bounds of the matrix
  if (i < 0) i = 0;
  if (i >= indicatorMatrix.length) i = indicatorMatrix.length - 1;

  const row = indicatorMatrix[i];
  console.log("Skier code " + row.code);

  // Now that we provide exact sole length, convert it to one of the brackets
  const soleIndex = GetSoleBracketIndex(soleLength);
  const setting = row.indicator[soleIndex];
  if (setting === undefined) {
    const nearest = GetNearestIndicator(row.indicator, soleIndex);
    return "N/A (" + nearest + ")";
  } else {
    return setting.toString();
  }
}

// Look for the nearest defined indicator setting
function GetNearestIndicator(indicators, index) {
  let result = 0;
  let distance = 999;
  for (let i = 0; i < indicatorMatrix.length; i++) {
    if (indicators[i] !== undefined) {
      if (Math.abs(index - i) < distance) {
        result = i;
        distance = Math.abs(index - i);
      }
    }
  }
  return indicators[result];
}

// Figure which bracket a sole length is in
function GetSoleBracketIndex(soleLength) {
  for (let i = 0; i < soleBracketStarts.length; i++) {
    if (soleBracketStarts[i] > soleLength) {
      return i - 1;
    }
  }
}